import { connect } from 'react-redux'
import ScrollToTop from './ScrollToTop'

const stateToProps = ({ routing }) => ({
  routing,
})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(ScrollToTop)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Scroll/ScrollToTop/ScrollToTop.container.js